import { render } from "./ListClientCategories.vue?vue&type=template&id=d1dc3640"
import script from "./ListClientCategories.vue?vue&type=script&lang=js"
export * from "./ListClientCategories.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__